module.exports = __webpack_public_path__ + "media/img/about/social/youtube-d27c0f03eac354c82c120fe016379558.png";